import type { SiteLanguage } from "./language";
import registry from "./legal-documents.json";

/** Languages the static documents under /documentation are actually published in. */
export type DocLang = keyof typeof registry.languages;

export const LEGAL_DOCS = registry.documents;
export type LegalDocument = keyof typeof LEGAL_DOCS;

/** Site language codes (profile settings) → document language codes. */
const SITE_TO_DOC_LANG: Record<SiteLanguage, string> = registry.siteLanguages;

export function legalDocLanguage(language: SiteLanguage): DocLang {
  const documentLanguage = SITE_TO_DOC_LANG[language];
  if (!(documentLanguage in registry.languages)) throw new Error(`Unsupported document language: ${documentLanguage}`);
  return documentLanguage as DocLang;
}

export function legalDocUrl(language: SiteLanguage, doc: LegalDocument) {
  return `/documentation/${legalDocLanguage(language)}-${LEGAL_DOCS[doc].public}.pdf`;
}
